// extracted by mini-css-extract-plugin
export default {"deleteModalContent":"style_deleteModalContent__Pd7Tw","deleteModalButtons":"style_deleteModalButtons__FpiRx"};